<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)"
     (pointerleave)="onPointerUp($event)">

  <defs>
    <!-- Brushed-metal bezel ring -->
    <linearGradient id="vc-bezel" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#E9EDF2" />
      <stop offset="30%" stop-color="#B9C2CE" />
      <stop offset="55%" stop-color="#8B97A6" />
      <stop offset="80%" stop-color="#B4BEC9" />
      <stop offset="100%" stop-color="#727E8E" />
    </linearGradient>
    <!-- Spun-steel dial face -->
    <radialGradient id="vc-face" cx="42%" cy="36%" r="72%">
      <stop offset="0%" stop-color="#F3F6F9" />
      <stop offset="55%" stop-color="#C9D1DB" />
      <stop offset="100%" stop-color="#98A2B2" />
    </radialGradient>
    <!-- Vault-door brushed slab -->
    <radialGradient id="vc-door" cx="40%" cy="34%" r="80%">
      <stop offset="0%" stop-color="#C6CFDA" />
      <stop offset="60%" stop-color="#9AA6B5" />
      <stop offset="100%" stop-color="#6C7889" />
    </radialGradient>
    <radialGradient id="vc-jamb" cx="42%" cy="38%" r="80%">
      <stop offset="0%" stop-color="#8A96A6" />
      <stop offset="100%" stop-color="#4C5766" />
    </radialGradient>
    <radialGradient id="vc-interior" cx="50%" cy="45%" r="70%">
      <stop offset="0%" stop-color="#2A2F3A" />
      <stop offset="100%" stop-color="#0E1116" />
    </radialGradient>
    <linearGradient id="vc-needle" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FF6B5E" />
      <stop offset="55%" stop-color="#F04438" />
      <stop offset="100%" stop-color="#C42E24" />
    </linearGradient>
    <linearGradient id="vc-hub" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#EDF1F6" />
      <stop offset="50%" stop-color="#A9B4C1" />
      <stop offset="100%" stop-color="#727E8E" />
    </linearGradient>
    <linearGradient id="vc-glass" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.42" />
      <stop offset="45%" stop-color="#FFFFFF" stop-opacity="0.06" />
      <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
    </linearGradient>
    <linearGradient id="vc-hopper" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#DCE6F0" stop-opacity="0.5" />
      <stop offset="100%" stop-color="#9FB2C6" stop-opacity="0.28" />
    </linearGradient>

    <filter id="vc-shadow" x="-40%" y="-40%" width="180%" height="180%">
      <feDropShadow dx="0" dy="8" stdDeviation="12" flood-color="#1D2530" flood-opacity="0.30" />
    </filter>
    <filter id="vc-needle-shadow" x="-60%" y="-60%" width="220%" height="220%">
      <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#3A1210" flood-opacity="0.35" />
    </filter>
    <filter id="vc-glow-amber" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="0" stdDeviation="10" flood-color="#FF7A1A" flood-opacity="0.9" />
    </filter>
    <filter id="vc-glow-green" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="0" stdDeviation="12" flood-color="#17B26A" flood-opacity="0.95" />
    </filter>
  </defs>

  <!-- ══ VAULT DOOR + DIAL assembly ══ -->
  <!-- Dark interior revealed once the door swings open -->
  <g class="vault-interior" [class.revealed]="doorOpen">
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R - 18" fill="url(#vc-interior)" />
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R - 18" fill="none" stroke="#0A0C10" stroke-width="6" />
    <text class="vault-open-word" [attr.x]="dialCX" [attr.y]="DIAL_CY + 6" text-anchor="middle">
      {{ currLang === 'ar' ? 'مفتوحة' : 'OPEN' }}
    </text>
  </g>

  <!-- Recessed jamb -->
  <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R + 8" fill="url(#vc-jamb)" filter="url(#vc-shadow)" />
  <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R + 2" fill="none" stroke="#3A424E" stroke-width="4" />

  <!-- Hinge barrels on the leading edge -->
  <g [attr.transform]="isAr ? 'translate(' + (dialCX - DOOR_R - 4) + ',' + DIAL_CY + ')' : 'translate(' + (dialCX + DOOR_R + 4) + ',' + DIAL_CY + ')'">
    <rect x="-9" y="-96" width="18" height="52" rx="8" fill="url(#vc-hub)" stroke="#5B6675" stroke-width="2" />
    <rect x="-9" y="44" width="18" height="52" rx="8" fill="url(#vc-hub)" stroke="#5B6675" stroke-width="2" />
  </g>

  <!-- The door swings open on a crack (rotateY / scaleX fallback) -->
  <g class="vault-door" [class.is-open]="doorOpen" [style.transform-origin]="dialCX + 'px ' + DIAL_CY + 'px'">
    <!-- Door slab -->
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R" fill="url(#vc-door)" />
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R - 2" fill="none" stroke="#E4EAF1" stroke-width="2" opacity="0.4" />
    <!-- brushed radial streaks -->
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R - 30" fill="none" stroke="#7E8A99" stroke-width="1" opacity="0.5" />
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="DOOR_R - 60" fill="none" stroke="#7E8A99" stroke-width="1" opacity="0.4" />

    <!-- Rim rivets -->
    <g>
      <circle *ngFor="let r of rivets" [attr.cx]="r.x" [attr.cy]="r.y" r="5" fill="#D6DDE6" stroke="#6C7889" stroke-width="1.5" />
    </g>

    <!-- Locking bolts (retract on a crack) -->
    <g class="bolts" [class.retracted]="doorOpen">
      <g *ngFor="let b of bolts" [attr.transform]="'translate(' + b.x + ',' + b.y + ') rotate(' + b.a + ')'">
        <rect class="bolt" x="-6" y="-9" width="26" height="18" rx="4" fill="url(#vc-hub)" stroke="#5B6675" stroke-width="1.5" />
      </g>
    </g>

    <!-- ══ SAFE DIAL ══ -->
    <!-- Knurled bezel ring -->
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="R_BEZEL" fill="url(#vc-bezel)" filter="url(#vc-shadow)" />
    <g class="knurls">
      <line *ngFor="let k of knurls" [attr.x1]="k.x1" [attr.y1]="k.y1" [attr.x2]="k.x2" [attr.y2]="k.y2"
            stroke="#6E7A8A" stroke-width="2" stroke-linecap="round" />
    </g>

    <!-- Warmth glow ring on the STATIC bezel (post-SET only) -->
    <circle *ngIf="committedShown && committedBand === 'green'" class="warm-ring" [attr.cx]="dialCX" [attr.cy]="DIAL_CY"
            [attr.r]="R_BEZEL - 2" fill="none" stroke="#17B26A" stroke-width="7" filter="url(#vc-glow-green)" />
    <circle *ngIf="committedShown && committedBand === 'amber'" class="warm-ring" [attr.cx]="dialCX" [attr.cy]="DIAL_CY"
            [attr.r]="R_BEZEL - 2" fill="none" stroke="#FF7A1A" stroke-width="6" filter="url(#vc-glow-amber)" />
    <circle *ngIf="committedShown && committedBand === 'grey'" class="warm-ring" [attr.cx]="dialCX" [attr.cy]="DIAL_CY"
            [attr.r]="R_BEZEL - 2" fill="none" stroke="#98A2B3" stroke-width="5" opacity="0.7" />

    <!-- Spun-steel face -->
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="R_FACE" fill="url(#vc-face)" />
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="R_FACE" fill="none" stroke="#7E8A99" stroke-width="2" />

    <!-- Fraction-ring benchmark marks (lit on the hint beat) -->
    <g class="fraction-ring" [class.lit]="hintVisible">
      <g *ngFor="let m of fractionMarks">
        <circle [attr.cx]="m.x" [attr.cy]="m.y - 5" r="13" fill="#FDF4E3" stroke="#F4A825" stroke-width="2" />
        <text class="frac-label" [attr.x]="m.x" [attr.y]="m.y" text-anchor="middle">{{ m.label }}</text>
      </g>
    </g>

    <!-- Minor + major ticks -->
    <g class="ticks">
      <line *ngFor="let t of minorTicks" class="tick-min" [attr.x1]="t.x1" [attr.y1]="t.y1" [attr.x2]="t.x2" [attr.y2]="t.y2"
            (click)="onTickTap(t.v)" />
      <line *ngFor="let t of majorTicks" class="tick-maj" [attr.x1]="t.x1" [attr.y1]="t.y1" [attr.x2]="t.x2" [attr.y2]="t.y2" />
    </g>

    <!-- Engraved numerals (double-painted, upright) -->
    <g class="numerals">
      <g *ngFor="let nm of numerals" (click)="onTickTap(nm.v)">
        <text class="numeral engrave" [attr.x]="nm.x" [attr.y]="nm.y" text-anchor="middle">{{ nm.label }}</text>
        <text class="numeral" [attr.x]="nm.x" [attr.y]="nm.y - 1" text-anchor="middle">{{ nm.label }}</text>
      </g>
    </g>

    <!-- RED pointer needle -->
    <g class="needle" [attr.transform]="needleTransform" filter="url(#vc-needle-shadow)">
      <path [attr.d]="'M ' + dialCX + ' ' + (DIAL_CY - NEEDLE_LEN) + ' L ' + (dialCX - 9) + ' ' + (DIAL_CY - 8) + ' L ' + (dialCX + 9) + ' ' + (DIAL_CY - 8) + ' Z'"
            fill="url(#vc-needle)" stroke="#8A1F17" stroke-width="1.5" stroke-linejoin="round" />
      <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY - NEEDLE_LEN + 6" r="3" fill="#FFE0DC" opacity="0.8" />
    </g>

    <!-- Machined hub / rivet -->
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" r="30" fill="url(#vc-hub)" stroke="#5B6675" stroke-width="2" />
    <circle [attr.cx]="dialCX" [attr.cy]="DIAL_CY" r="12" fill="#8B97A6" stroke="#4C5766" stroke-width="2" />
    <circle [attr.cx]="dialCX - 4" [attr.cy]="DIAL_CY - 4" r="3" fill="#FFFFFF" opacity="0.7" />

    <!-- Centre engraved label (sub-skill dependent) — ABOVE the hub + needle base,
         on a subtle rounded plate so both lines stay fully readable. -->
    <g class="center-label-group">
      <rect [attr.x]="dialCX - 54" [attr.y]="DIAL_CY - 84" width="108" height="46" rx="11"
            fill="#EEF2F6" opacity="0.8" stroke="#CBD3DD" stroke-width="1" />
      <text class="center-label" [attr.x]="dialCX" [attr.y]="DIAL_CY - 63" text-anchor="middle">{{ centerLabel.top }}</text>
      <text class="center-label" [attr.x]="dialCX" [attr.y]="DIAL_CY - 45" text-anchor="middle">{{ centerLabel.bottom }}</text>
    </g>

    <!-- Selected-number pill riding near the needle tip (upright) -->
    <g class="sel-pill" [class.solved]="solvedState">
      <rect [attr.x]="pill.x - 30" [attr.y]="pill.y - 20" width="60" height="40" rx="20"
            fill="#0074EC" stroke="#FFFFFF" stroke-width="3" />
      <text class="sel-num" [attr.x]="pill.x" [attr.y]="pill.y + 8" text-anchor="middle">{{ selectedLabel }}</text>
    </g>

    <!-- Glass cover specular glint (never intercepts pointer) -->
    <path [attr.d]="'M ' + (dialCX - R_FACE + 20) + ' ' + (DIAL_CY - R_FACE + 60) + ' A ' + R_FACE + ' ' + R_FACE + ' 0 0 1 ' + (dialCX + R_FACE - 60) + ' ' + (DIAL_CY - R_FACE + 20)"
          fill="none" stroke="url(#vc-glass)" stroke-width="26" stroke-linecap="round" pointer-events="none" opacity="0.7" />

    <!-- Transparent dial hit area for dragging the needle -->
    <circle class="dial-hit" [attr.cx]="dialCX" [attr.cy]="DIAL_CY" [attr.r]="R_FACE" fill="transparent"
            (pointerdown)="onDialDown($event)" />
  </g>

  <!-- Direction arrow arc (post-SET only, more/less) -->
  <g *ngIf="committedShown && !solvedState && arrowDir" class="dir-arrow" [class.more]="arrowDir === 'more'">
    <path [attr.d]="arrowArc" fill="none" stroke="#0B2447" stroke-width="6" stroke-linecap="round" opacity="0.85" />
    <text class="dir-label" [attr.x]="arrowLabelPos.x" [attr.y]="arrowLabelPos.y" text-anchor="middle">{{ arrowLabel }}</text>
  </g>

  <!-- ══ LOOT HOPPER + gem pile ══ -->
  <g class="loot">
    <!-- Glass hopper — outer body -->
    <path [attr.d]="'M ' + (lootCX - 78) + ' 130 L ' + (lootCX + 78) + ' 130 L ' + (lootCX + 46) + ' 300 L ' + (lootCX - 46) + ' 300 Z'"
          fill="url(#vc-hopper)" stroke="#B7C4D2" stroke-width="3" stroke-linejoin="round" />
    <!-- inner glass wall (visible thickness) -->
    <path [attr.d]="'M ' + (lootCX - 68) + ' 140 L ' + (lootCX + 68) + ' 140 L ' + (lootCX + 40) + ' 292 L ' + (lootCX - 40) + ' 292 Z'"
          fill="none" stroke="#FFFFFF" stroke-width="1.5" opacity="0.28" stroke-linejoin="round" />
    <!-- specular sheen down the left wall -->
    <path [attr.d]="'M ' + (lootCX - 70) + ' 140 L ' + (lootCX - 44) + ' 292'" fill="none" stroke="#FFFFFF" stroke-width="4" opacity="0.55" stroke-linecap="round" />
    <path [attr.d]="'M ' + (lootCX - 58) + ' 143 L ' + (lootCX - 36) + ' 290'" fill="none" stroke="#FFFFFF" stroke-width="1.5" opacity="0.32" stroke-linecap="round" />
    <!-- right wall shade -->
    <path [attr.d]="'M ' + (lootCX + 70) + ' 143 L ' + (lootCX + 44) + ' 292'" fill="none" stroke="#6E7F92" stroke-width="2" opacity="0.3" stroke-linecap="round" />
    <!-- metal rim cap + rim highlight -->
    <rect [attr.x]="lootCX - 88" y="118" width="176" height="18" rx="6" fill="url(#vc-hub)" stroke="#6C7889" stroke-width="2" />
    <rect [attr.x]="lootCX - 84" y="121" width="168" height="4" rx="2" fill="#FFFFFF" opacity="0.5" />

    <!-- Collecting tray — machined bowl with rim + sheen -->
    <path [attr.d]="'M ' + (lootCX - 118) + ' 496 Q ' + lootCX + ' 548 ' + (lootCX + 118) + ' 496 L ' + (lootCX + 108) + ' 520 Q ' + lootCX + ' 560 ' + (lootCX - 108) + ' 520 Z'"
          fill="url(#vc-hub)" stroke="#5B6675" stroke-width="2" stroke-linejoin="round" />
    <path [attr.d]="'M ' + (lootCX - 110) + ' 500 Q ' + lootCX + ' 540 ' + (lootCX + 110) + ' 500'"
          fill="none" stroke="#EDF1F6" stroke-width="3" stroke-linecap="round" opacity="0.7" />
    <path [attr.d]="'M ' + (lootCX - 118) + ' 496 Q ' + lootCX + ' 548 ' + (lootCX + 118) + ' 496'"
          fill="none" stroke="#3A424E" stroke-width="2" stroke-linecap="round" opacity="0.5" />

    <!-- Gems already resting in the tray BEFORE the crack (deterministic) -->
    <g class="resting-gems">
      <g *ngFor="let g of restingGems" [attr.transform]="'translate(' + g.x + ',' + g.y + ')'">
        <ng-container *ngIf="g.coin; else restFacet">
          <ellipse cx="0" cy="0" rx="11" ry="11" fill="#FDB022" stroke="#B77908" stroke-width="1.5" />
          <ellipse cx="0" cy="0" rx="6" ry="6" fill="none" stroke="#B77908" stroke-width="1.2" opacity="0.7" />
          <ellipse cx="-3" cy="-3" rx="2.4" ry="2.4" fill="#FFF2C6" opacity="0.8" />
        </ng-container>
        <ng-template #restFacet>
          <polygon points="0,-12 10,-3 6,11 -6,11 -10,-3" [attr.fill]="g.color" stroke="#0B2447" stroke-width="1.2" stroke-linejoin="round" opacity="0.95" />
          <polygon points="0,-12 10,-3 0,-2 -10,-3" fill="#FFFFFF" opacity="0.32" />
          <polygon points="0,-2 6,11 -6,11" fill="#000000" opacity="0.14" />
        </ng-template>
      </g>
    </g>

    <!-- Precomputed hex-stacked gem pile (dispensed on a crack) -->
    <g class="gems">
      <g *ngFor="let g of gemPile" [attr.transform]="'translate(' + g.x.toFixed(1) + ',' + g.y.toFixed(1) + ')'">
        <g class="gem" [class.dropped]="solvedState" [style.animation-delay.ms]="g.delay">
          <ng-container *ngIf="g.coin; else facetGem">
            <ellipse cx="0" cy="0" rx="11" ry="11" fill="#FDB022" stroke="#B77908" stroke-width="1.5" />
            <ellipse cx="0" cy="0" rx="6" ry="6" fill="none" stroke="#B77908" stroke-width="1.2" opacity="0.7" />
            <ellipse cx="-3" cy="-3" rx="2.4" ry="2.4" fill="#FFF2C6" opacity="0.8" />
          </ng-container>
          <ng-template #facetGem>
            <polygon points="0,-12 10,-3 6,11 -6,11 -10,-3" [attr.fill]="g.color" stroke="#0B2447" stroke-width="1.2" stroke-linejoin="round" opacity="0.95" />
            <polygon points="0,-12 10,-3 0,-2 -10,-3" fill="#FFFFFF" opacity="0.32" />
            <polygon points="0,-2 6,11 -6,11" fill="#000000" opacity="0.14" />
          </ng-template>
        </g>
      </g>
    </g>

    <!-- Loot readout chip (counts up 1..answer on a crack) -->
    <g class="loot-chip" [class.show]="solvedState">
      <rect [attr.x]="lootCX - 46" y="70" width="92" height="40" rx="20" fill="#0B2447" />
      <text class="loot-count" [attr.x]="lootCX" y="97" text-anchor="middle">{{ dig(gemCount) }}</text>
    </g>
  </g>
</svg>
